module.exports = __webpack_public_path__ + "img/3-Chartwelle Green 49246.jpg";